module.exports = __webpack_public_path__ + "img/logo.cd4e9ffd.png";